import { Pill } from "@/components/podkit/status/Pill";
import { TableCell, TableRow } from "@/components/podkit/tables/Table";
import { useGroupRunners } from "@/hooks/use-group-runners";
import type { PlainRunner } from "@/queries/runner-queries";
import { formatRunnerProvider, formatRunnerStatus } from "@/utils/group-resources";
import { RunnerProvider } from "gitpod-next-api/gitpod/v1/runner_configuration_pb";
import { RunnerPhase } from "gitpod-next-api/gitpod/v1/runner_pb";
import type { FC } from "react";
import { CollapsibleSection } from "@/components/settings/organization/groups/CollapsibleSection";

export type RunnersSectionProps = {
    groupId: string;
};

export const RunnersSection: FC<RunnersSectionProps> = ({ groupId }) => {
    const { runners, isLoading } = useGroupRunners(groupId);

    const title = `${runners.length} ${runners.length === 1 ? "Runner" : "Runners"}`;
    const headers = ["Name", "Runner type", "Status"];

    return (
        <CollapsibleSection
            title={title}
            headers={headers}
            isLoading={isLoading}
            isEmpty={runners.length === 0}
        >
            {runners.map((runner) => (
                <RunnerTableRow key={runner.runnerId} runner={runner} />
            ))}
        </CollapsibleSection>
    );
};

type RunnerTableRowProps = {
    runner: PlainRunner;
};

const RunnerTableRow: FC<RunnerTableRowProps> = ({ runner }) => {
    const status = formatRunnerStatus(runner.status?.phase ?? RunnerPhase.UNSPECIFIED);

    return (
        <TableRow>
            <TableCell>{runner.name || "Unnamed"}</TableCell>
            <TableCell>
                <span className="text-muted-foreground">
                    {formatRunnerProvider(runner.provider ?? RunnerProvider.UNSPECIFIED)}
                </span>
            </TableCell>
            <TableCell>
                <Pill variant={status.variant}>{status.label}</Pill>
            </TableCell>
        </TableRow>
    );
};
